import {SimpleBlueButton} from '../../core/button'
import Tooltip from '../../core/tooltip'
import ButtonLoader from '../../core/button/ButtonLoader'
import PieProgressChart from '../pieProgressChart'
import ListView from './listView'
import StatisticsIcon from '../../../assets/images/statistics-icon.svg'
import StatisticsDarkIcon from '../../../assets/images/statistics-icon-dark.svg'
import './index.scss'
import {useSelector} from 'react-redux'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const RulesetListView = ({
    data,
    showFormViewModal,
    showEditModal,
    rulesetUsageLimit,
    onSaveRulesets,
    onDeleteRuleset,
    isSaveDisabled,
    isSaving,
    highlightedMetricKeys
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const text = useNamespaceTranslations('rulesets')
    const hasPendingChanges = onSaveRulesets && isSaveDisabled === false
    const hasData = data?.length > 0 || hasPendingChanges
    const isLimitExceeded = rulesetUsageLimit?.usage >= rulesetUsageLimit?.value

    const createButton = (className) => {
        const button = (
            <SimpleBlueButton
                className={className}
                onClick={showFormViewModal}
                disabled={isLimitExceeded}
            >
                {text.create}
            </SimpleBlueButton>
        )

        return isLimitExceeded ? (
            <Tooltip placement="top" content={text.usage_limit_exceeded} trigger="mouseenter">
                {button}
            </Tooltip>
        ) : button
    }

    return (
        <div className="rulesets-list-container">
            {hasData ? (
                <>
                    <div className='rulesets-usage-details'>
                        {createButton('add-rulesets-button cancel-button')}
                        <PieProgressChart
                            value={rulesetUsageLimit.usage}
                            max={rulesetUsageLimit.value}
                            config={{
                                tooltip_text: text.usage_text,
                                label_text: text.usage
                            }}
                        />
                    </div>
                    {!data?.length && hasPendingChanges ? (
                        <div className="rulesets-pending-changes-text">{text.pending_changes_text}</div>
                    ) : (
                        <ListView
                            data={data}
                            isDarkMode={isDarkMode}
                            showEditModal={(item) => showEditModal(item)}
                            onDeleteClick={onDeleteRuleset}
                            highlightedMetricKeys={highlightedMetricKeys}
                        />
                    )}
                    {onSaveRulesets && (
                        <div className='rulesets-footer-actions'>
                            <SimpleBlueButton
                                className='save-rulesets-button'
                                onClick={onSaveRulesets}
                                disabled={isSaveDisabled || isSaving}
                            >
                                {isSaving && <ButtonLoader />}
                                {text.update_rulesets}
                            </SimpleBlueButton>
                        </div>
                    )}
                </>
            ) : (
                <div className="no-rulesets">
                    <img
                        src={isDarkMode ? StatisticsDarkIcon : StatisticsIcon}
                        alt="Statistics"
                        className="no-rulesets-image"
                    />
                    {createButton()}
                </div>
            )}
        </div>
    )
}

export default RulesetListView
